import { InjectionToken } from '@angular/core';

/**
 * Signaling-server URL for WebRTC replication. `app.config` provides it from the environment; unit tests that
 * transitively construct the replication feature (e.g. via HordeReplicationStore or BracketReplicationStore) must
 * provide it explicitly - an empty string is fine there since replication never actually connects under test.
 */
export const WEBRTC_SIGNALING_URL = new InjectionToken<string>('WEBRTC_SIGNALING_URL');
